import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { map, tap } from 'rxjs/operators';
import { ProviderService } from '../models/provider-service.model';
import { Observable, combineLatest, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class ProviderServiceService {

  private services:Subject<Array<ProviderService>> = new ReplaySubject<Array<ProviderService>>(1);
  services$ = this.services.asObservable();

  private allServices:Subject<Array<Object>> = new ReplaySubject<Array<Object>>(1);
  allServices$ = this.allServices.asObservable();

  constructor( private http: HttpClient ) { 
  }

  addServices( services: Array<ProviderService>) {
    this.services.next( services );
  }

  addAllServices( allServices: Array<Object>) {
    this.allServices.next( allServices );
  }

  getServicesByLocationId( locationId ) {

    
    let url = environment.apiUrl + '/views/services_at_location/' + locationId + '?expand=children';

    const responseToModel = ( response: any): any =>  {

      if ( response._embedded && response._embedded.servicesatlocation && response._embedded.servicesatlocation[0] ) {
          return response._embedded.servicesatlocation[0];
      } 

    } 

    return this.http.get( url ).pipe(
      
      map( response => responseToModel( response ) ),
      tap( result => this.addAllServices( result ) )

    );

    //result.subscribe( data => console.log( data ) );

  }

  private lastTwoLevelsList( graph, pick = null ) {

    let result = [];

    this.recursion( graph, result, graph, pick );

    return result;

  }

  private recursion( input, result, parent, pick ) {

    if ( !input.visibleForCustomers ) {
      return false;
    }

    //rožmarin exceptions
    if ( input.id === 18656 && pick && ( pick.combination.start < '2022-12-17' || pick.combination.start > '2022-12-18' )) { //brunch
      return false;  
    }

    if ( input.id === 18665 && pick && ( pick.combination.start < '2022-12-31' || pick.combination.start > '2023-01-01' )) { //silvestrovanje
      return false;  
    }

    if ( input.id === 18660 && pick && ( pick.combination.start < '2022-12-31' || pick.combination.start > '2023-01-01' )) { //silvestrovanje
      return false;  
    }

    if ( input.children && input.children.length > 0 ) {
      for ( var value of input.children ) {

        this.recursion( value, result, input, pick );

      }

    } else {

      //hackatlon, ugly, please rewrite
      let alreadyExists = false;
      for ( var value2 of result ) {
        if ( value2.id === parent.id ) {
          alreadyExists = true;
        }
      }

      if ( !alreadyExists ) {
        result.push( parent );
      }

    }

  }

  getServicesForPicking( locationId, pick = null ) {

    let serviceGraph$ = this.getServicesByLocationId( locationId );

    return serviceGraph$.pipe(
      map( response => this.lastTwoLevelsList( response, pick ) ),
      tap( result => this.addServices( result ) )
    );

  }

}